import { Users, BookOpen, Award, Activity } from "lucide-react";
import { MetricCard } from "./metric-card";

export function SummaryCards({ metrics }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        title="Total Students"
        value={metrics.totalStudents.toLocaleString()}
        icon={<Users className="h-4 w-4 text-muted-foreground" />}
      />
      <MetricCard
        title="Active Courses"
        value={metrics.activeCourses.toString()}
        icon={<BookOpen className="h-4 w-4 text-muted-foreground" />}
      />
      <MetricCard
        title="Completion Rate"
        value={`${metrics.avgCompletionRate}%`}
        icon={<Award className="h-4 w-4 text-muted-foreground" />}
      />
      <MetricCard
        title="Student Engagement"
        value={`${metrics.studentEngagement}%`}
        icon={<Activity className="h-4 w-4 text-muted-foreground" />}
      />
    </div>
  );
}
